import React, { FC } from 'react';
import { Field, useFormState } from 'react-final-form';
import { Collapse } from '@mui/material';
import { intValuesHelpers } from '@factorin/util';

import { WithT } from 'Modules/core/i18n';
import { InputField, RadioElement, Stack } from 'Modules/ui3';
import { RadioGroupField, SliderField } from 'Modules/business/forms';
import { validators } from 'Modules/core/forms';

import { investorTypes, investorStatus } from './utils';
import { FormValues, Role } from '../types';
import { useListTranslate } from '../../../utils';
import { useRateValueFormatter, innValidatorsByRole, needInnTypes } from '../utils';


export const InvestorBlock: FC<WithT> = ({ t }) => {
    const { values } = useFormState<FormValues>();
    const rateFormatter = useRateValueFormatter(t);
    return (
        <Stack spacing={4}>
            <Field
                name='rate'
                label={t('fields.rate', { context: Role[Role.INVESTOR] })}
                component={SliderField}
                min={-5}
                max={5}
                step={0.25}
                valueLabelFormat={rateFormatter}
            />
            <Field
                name='investorType'
                groupLabel={t('fields.investorType')}
                component={RadioGroupField}
                elements={useListTranslate<RadioElement>(t, investorTypes)}
                validate={values?.role === Role.INVESTOR &&
                    validators.requiredKey('investorTypeRequired')}
                spacing={2}
                parse={value => +value || undefined}
                required
            />
            <Collapse in={needInnTypes.includes(values?.investorType)} mountOnEnter unmountOnExit>
                <Field
                    name='inn'
                    key={values.role}
                    component={InputField}
                    label={t('fields.inn')}
                    validate={(value, values: FormValues) =>
                        innValidatorsByRole[values.role](value, values)}
                    parse={intValuesHelpers.parse}
                    required
                />
            </Collapse>
            <Field
                name='investorStatus'
                groupLabel={t('fields.investorStatus')}
                component={RadioGroupField}
                elements={useListTranslate<RadioElement>(t, investorStatus)}
                validate={values?.role === Role.INVESTOR &&
                    validators.requiredKey('isQualifiedRequired')}
                spacing={2}
                parse={value => +value || undefined}
                required
            />
        </Stack>
    );
};
